var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BTab",
    _vm._b(
      {
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function () {
                return [_vm._t("title")]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      },
      "BTab",
      _vm.$attrs,
      false
    ),
    [_vm._v(" "), _vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }